<template>
<div>
  <el-cascader style="width: 300px" ref="selectArea" v-model="self_area_ids" :props="{ checkStrictly: true }" :options="area_list" @change="selectAreaChange" clearable></el-cascader>
</div>
</template>

<script>
import CommonHelp from "../common/CommonHelp";

export default {
  name: "SelectContractArea",
  props:{
    pid:{
      type:Number,
      default(){
        return 0;
      }
    },
    area_ids:{
      type:String,
      default(){
        return '';
      }
    },
  },
  data(){
    return{
      area_list:[],
      self_area_ids:"",
    }
  },
  created() {
    this.getData();
    this.initData();
  },
  methods:{
    initData(){
      if(this.area_ids){
        this.self_area_ids=this.area_ids.split(',').map(ret=>{return ret*1});
      }else {
        this.self_area_ids=''
      }
    },
    getData(){
      var that=this;
      CommonHelp.get('Project/getContractAreaList',{pid:that.pid},ret=>{
        if(ret.code){
          that.area_list=ret.data;
        }
      })
    },
    selectAreaChange(item){
      let checkedNodes=this.$refs.selectArea.getCheckedNodes(item)
      let checkedNode=checkedNodes[0]
      let selectData=[];
      (((checkedNode.parent||{}).parent||{}).parent||{}).parent&&selectData.push(checkedNode.parent.parent.parent.parent.data)
      ((checkedNode.parent||{}).parent||{}).parent&&selectData.push(checkedNode.parent.parent.parent.data)
      (checkedNode.parent||{}).parent&&selectData.push(checkedNode.parent.parent.data)
      checkedNode.parent&&selectData.push(checkedNode.parent.data)
      checkedNode.data&&selectData.push(checkedNode.data)
      this.$emit("onAreaChange", {data:checkedNode.data,pathData:selectData,ids:item});
    }
  },
  watch:{
    area_ids(n){
      this.initData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/SelectContractArea.vue